import React, { Component, PropTypes } from 'react';
import TetherComponent from 'react-tether';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import AvailabilityIndicator from './AvailabilityIndicator.js';
import UserAvatar from './UserAvatar.js';

import availabilityLabel from '../utils/availability-label.js';
import isElectron from '../utils/is-electron.js';

// Import the Bootstrap header.
import './Header.css';

class Header extends Component {
  handleWindowClick = (ev) => {
    const { closePopovers, popoverState } = this.props;
    const { openPopover } = popoverState;
    const { target } = ev;

    if (!openPopover) {
      // If there isn't a popover currently open, don't worry about the click!
      return;
    }

    // If we're clicking the buttons to open/close the popovers, ignore it!
    if (this.rightHeaderSectionRef.contains(target)) {
      return;
    }

    ev.preventDefault();
    ev.stopPropagation();

    // Get the react-tether instance of the popover nodes and grab the .element.
    let notificationPopoverInstance = this.notificationPopoverRef.getTetherInstance().element;
    let profilePopoverInstance = this.profilePopoverRef.getTetherInstance().element;

    // If the user clicked outside one of the popovers, close the popovers!
    let clickedInsidePopovers = notificationPopoverInstance.contains(target) || profilePopoverInstance.contains(target);

    if (!clickedInsidePopovers) {
      closePopovers();
    }
  }

  componentWillMount() {
    document.addEventListener('click', this.handleWindowClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleWindowClick);
  }

  toggleNotificationPopover = () => {
    this.props.toggleNotificationPopover();
  }

  toggleProfilePopover = () => {
    this.props.toggleProfilePopover();
  }

  render() {
    const { notificationPopover, profilePopover, notificationCount, session } = this.props;
    const { user } = session;

    let links = [
      { label: 'Home', to: '/app/home' },
      { label: 'Backpack', to: '/app/backpack' },
      // { label: 'Feedback', to: '/app/feedback' },
      // { label: 'Report', to: '/app/report' },
      { label: 'Invite', to: '/app/invite' }
    ];

    // Don't show the availability label if the user isn't in Electron.
    let availability;
    if (isElectron()) {
      let statusLabel = availabilityLabel(user.availability);
      availability = (
        <span className="Header__profile-availability"><AvailabilityIndicator availability={user.availability} /> {statusLabel}</span>
      );
    }

    if (this.props.session.user && this.props.session.user.admin) {
      links.push({ label: 'Admin', to: '/app/admin' });
    }

    links = links.map((link) => {
      return <li key={link.label}><Link activeClassName='active' to={link.to}>{link.label}</Link></li>;
    });

    let notificationBadge;
    if (notificationCount) {
      notificationBadge = <span className="Header__notifications-count">{notificationCount}</span>;
    }

    return (
      <div className="Header">
        <ul className="Header__List HeaderSection--left">
          {links}
        </ul>

        <section className="HeaderSection--right" ref={(r) => this.rightHeaderSectionRef = r}>
          <TetherComponent attachment="top right"
            ref={(r) => this.notificationPopoverRef = r}
            targetAttachment="bottom left"
            offset="0 -144px"
            constraints={[{ to: 'scrollParent' }]}>
            <section className="Header__button" id="HeaderNotificationsButton" onClick={this.toggleNotificationPopover}>
              <a className="Header__notifications-link">
                {notificationBadge}
                <svg className="Header__notifications-icon" width="25" height="27" viewBox="0 0 25 27" xmlns="http://www.w3.org/2000/svg"><path d="M22.197 17.45c-.416.17-3.215-2.038-5.004-6.201-1.789-4.162-1.564-7.968-1.148-8.137.416-.168 3.146 2.495 4.934 6.657 1.789 4.162 1.634 7.512 1.218 7.682m.801-8.688C20.697 3.408 16.993-.67 15.118.092c-3.182 1.293 1.897 7.505-13.73 13.857-1.35.548-1.692 2.744-1.127 4.057.564 1.313 2.41 2.619 3.76 2.07.233-.094 1.092-.37 1.092-.37.964 1.293 1.973.526 2.33 1.348.43.988 1.366 3.135 1.683 3.866.319.73 1.04 1.406 1.563 1.207l2.98-1.134c.68-.258.842-.864.634-1.342-.224-.516-1.143-.667-1.405-1.268s-1.118-2.528-1.365-3.135c-.335-.826.377-1.498 1.41-1.605 7.113-.742 8.442 3.65 10.864 2.666 1.874-.762 1.493-6.19-.809-11.546" fillRule="evenodd"/></svg>
              </a>
            </section>

            {notificationPopover}
          </TetherComponent>

          <TetherComponent attachment="top right"
            ref={(r) => this.profilePopoverRef = r}
            targetAttachment="bottom left"
            offset="0 -144px"
            constraints={[{ to: 'scrollParent' }]}>
            <section className="Header__profile Header__button" id="HeaderProfileButton" onClick={this.toggleProfilePopover}>

              <UserAvatar user={user} wrapperClassName="Header__profile-avatar-wrap" />
              <div className="Header__profile-info">
                <span className="Header__profile-name">{user.displayName}<svg className="Header__profile-drop" width="8" height="5" viewBox="0 0 8 5" xmlns="http://www.w3.org/2000/svg"><path d="M0 0l3.828 4.608L7.668 0z" fill="#FFF" fillRule="evenodd"/></svg></span>
                {availability}
              </div>
            </section>
            {profilePopover}
          </TetherComponent>
        </section>
      </div>
    );
  }
}

Header.propTypes = {
  toggleNotificationPopover: PropTypes.func.isRequired,
  toggleProfilePopover: PropTypes.func.isRequired,
  closePopovers: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    session: state.session,
    friends: state.friends,
    popoverState: state.popover
  };
};

export default connect(mapStateToProps, null)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js